// extracted by mini-css-extract-plugin
export var btn = "week-switcher-module--btn--Ege1t";
export var btnHolder = "week-switcher-module--btn-holder--CkAFr";
export var weekSwitcher = "week-switcher-module--week-switcher--XVcTA";